import { SideListOrganizations } from '../../../../widgets/side-list-organizations/ui/side-list-organizations';
import React from 'react';

export const SideViewAdmin: React.FC = () => {
    return <SideListOrganizations />;
};
